import { Button } from "design_system_radar/button";
import { ServerCrash } from "lucide-react";

import { routes } from "@/config/routing/routes";
import { useBackendStatus } from "@/hooks/useBackendStatus";

import AuthSplitLayout from "../auth/AuthSplitLayout";

type ServiceUnavailablePageProps = {
  statusCode?: number;
};

function ServiceUnavailablePage({ statusCode }: ServiceUnavailablePageProps) {
  const clearBackendUnavailable = useBackendStatus(
    (state) => state.clearBackendUnavailable,
  );

  const handleRetry = () => {
    clearBackendUnavailable();
    window.location.reload();
  };

  return (
    <AuthSplitLayout
      description={
        <>
          Intenta actualizar la página de tu navegador o volver al{" "}
          <a
            className="font-semibold text-white underline"
            href={routes.approvals_v2.absolute}
          >
            inicio
          </a>
          .<br />
          Si el problema persiste, contacta a tu representante de Radar.
        </>
      }
      title="Ocurrió un problema inesperado"
    >
      <div className="space-y-8">
        <div className="flex items-center gap-3 text-[13px] text-white/40">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/[0.06] ring-1 ring-inset ring-white/[0.08]">
            <ServerCrash className="h-4 w-4" strokeWidth={1.5} />
          </div>
          <span>
            {statusCode
              ? `Código de respuesta: ${statusCode}`
              : "Servicio temporalmente no disponible"}
          </span>
        </div>

        <Button
          className="h-[42px] w-full rounded-lg"
          size="lg"
          type="button"
          variant="primary"
          onClick={handleRetry}
        >
          Reintentar
        </Button>
      </div>
    </AuthSplitLayout>
  );
}

export default ServiceUnavailablePage;
